/*
|--------------------------------------------------------------------------
| CONTENTFUL ENTRY IDS
|--------------------------------------------------------------------------
*/

/** Contentful entry ID for navigation/sidebar labels */
export const NAVIGATION_LABELS_ID = '3VELfyNnsE7EVI4sEb47rx';

/**
 * Contentful entry ID for Login page labels.
 * Contentful entry `lupp-login`. The label fetch is disabled while this is blank.
 */
export const LOGIN_LABELS_ID = 'RYzmCEpiuyTWGeY6ZxVcRp';

/** Contentful entry ID for Accept Invitation page labels */
export const ACCEPT_INVITATION_LABELS_ID = '6WHXMhiJlf64IjngoIFQvJ';

/** Contentful entry ID for Admin / Workspace Access labels */
export const WORKSPACE_ACCESS_LABELS_ID = '6BqVZ9X8vHKjR2YwQnMtPL';

/** Contentful entry ID for Prospect Desk / Create New Prospect labels */
export const CREATE_NEW_PROSPECT_LABELS_ID = '4bKjJdtPivFmf27zAfOSK5';

/** Contentful entry ID for Prospect Desk / Prospects labels */
export const PROSPECTS_LABELS_ID = '6dhtpdHCYn1jTZ1cRAXtJR';

/** Contentful entry ID for Manage Orders labels */
export const MANAGE_ORDERS_LABELS_ID = '4Gjtd2V6GQE26D0pFnzh1i';

/** Contentful entry ID for Order Desk labels */
export const ORDER_DESK_LABELS_ID = '1WTeI8ZeS6KNR1EcIYfJir';

/** Contentful entry ID for Order Builder labels */
export const ORDER_BUILDER_LABELS_ID = 'MExmNj8TDROSQt0YBpb5E';

/**
 * Contentful entry ID for Prospect Desk / Test Drive Bookings labels.
 * Missing keys fall back to English defaults in the page components.
 */
export const TEST_DRIVE_BOOKINGS_LABELS_ID = '3p0cEUbPEwET8iJwaeNlna';

/**
 * Default locale when no user preference is persisted.
 * German market is the primary launch market.
 */
export const DEFAULT_LOCALE = 'de-de';

/** Default language override — English labels for non-English locales */
export const DEFAULT_LANGUAGE = 'en';
